import { BottomNavigation, BottomNavigationAction } from '@mui/material'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $currentTab, $isNavSmoothVisible, $isNavVisible } from '@/entities/navigation/store'
import { lang } from '@/shared/constants/lang'
import { $userLanguage } from '@/entities/user'
import { goToMain, goToShop, goToSocial, goToTasks, goToUnifiedProfile } from '@/app/routing/events'
import WebApp from '@twa-dev/sdk'
import { Icon } from '@/shared/ui/icon'
import { darkTheme } from '@/shared/styles/theme/dark'

function NavBar() {
  const { classes } = useStyles({})

  const currentTab = useUnit($currentTab)
  const isNavVisible = useUnit($isNavVisible)
  const isNavSmoothVisible = useUnit($isNavSmoothVisible)
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].tabs

  function handleChangeWidget() {
    WebApp.HapticFeedback.impactOccurred('soft')
  }

  if (!isNavVisible) return null
  if (isNavVisible)
    return (
      <BottomNavigation
        showLabels
        value={currentTab}
        onChange={handleChangeWidget}
        classes={{ root: classes.bottomNav }}
        sx={{
          zIndex: 99,
          width: '100%',
          flexDirection: 'row',
          backgroundColor: darkTheme.colors.background.primary,
          boxShadow: '0px -5px 10px 0px rgba(0,0,0,0.1488)',
          transition: 'transform 0.3s ease',
          transform: isNavSmoothVisible ? 'translateY(0%)' : 'translateY(100%)',
          height: '10vh',
          paddingBottom: WebApp.platform == 'ios' ? '2vh' : '0px',
          alignItems: 'center',
          position: 'fixed',
          bottom: 0,
        }}
      >
        <BottomNavigationAction
          className={classes.bottomNavButton}
          onClick={() => {
            goToMain()
          }}
          label={texts.main}
          icon={<Icon view="main" />}
        />

        <BottomNavigationAction
          className={classes.bottomNavButton}
          onClick={() => {
            goToShop({ tab: 1 })
          }}
          label={texts.shop}
          icon={<Icon view="shop" />}
        />
        <BottomNavigationAction
          className={classes.bottomNavButton}
          onClick={() => goToUnifiedProfile()}
          label={texts.profile}
          icon={<Icon view="profile" />}
        />
        <BottomNavigationAction
          className={classes.bottomNavButton}
          onClick={() => goToSocial({ tab: 1 })}
          label={texts.friends}
          icon={<Icon view="social" style={{ height: '24px', width: 'auto' }} />}
        />
        <BottomNavigationAction
          className={classes.bottomNavButton}
          onClick={() => goToTasks()}
          label={texts.tasks}
          icon={<Icon view="tasks" />}
        />
      </BottomNavigation>
    )
}

export default NavBar
